// src/components/ItemModifierModalSkeleton.tsx
import React from 'react';

/**
 * Loading skeleton for ItemModifierModal
 * Displays animated placeholders while menu item details are being fetched
 */
export const ItemModifierModalSkeleton: React.FC = () => (
  <div className="animate-pulse">
    {/* Sticky Header Skeleton */}
    <div className="sticky top-0 z-10 bg-gray-100 px-4 py-4 flex items-center justify-between border-b border-gray-200">
      <div className="h-6 bg-gray-300 rounded w-48"></div>
      <div className="w-10 h-10 bg-gray-300 rounded-full"></div>
    </div>

    {/* Scrollable Content Skeleton */}
    <div className="p-4 space-y-6">
      {/* Modifier Group 1 */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="h-5 bg-gray-300 rounded w-40"></div>
          <div className="h-4 bg-gray-200 rounded w-24"></div>
        </div>
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex items-center justify-between py-3 border-b border-gray-200">
            <div className="flex items-center gap-3 flex-1">
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              <div className="h-4 bg-gray-300 rounded w-32"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded w-12"></div>
          </div>
        ))}
      </div>

      {/* Modifier Group 2 */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="h-5 bg-gray-300 rounded w-36"></div>
          <div className="h-4 bg-gray-200 rounded w-20"></div>
        </div>
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex items-center justify-between py-3 border-b border-gray-200">
            <div className="flex items-center gap-3 flex-1">
              <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
              <div className="h-4 bg-gray-300 rounded w-28"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </div>
        ))}
      </div>

      {/* Modifier Group 3 */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="h-5 bg-gray-300 rounded w-44"></div>
          <div className="h-4 bg-gray-200 rounded w-28"></div>
        </div>
        {[...Array(5)].map((_, i) => (
          <div key={i} className="flex items-center justify-between py-3 border-b border-gray-200">
            <div className="flex items-center gap-3 flex-1">
              <div className="w-5 h-5 bg-gray-300 rounded"></div>
              <div className="h-4 bg-gray-300 rounded w-36"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded w-14"></div>
          </div>
        ))}
      </div>
    </div>

    {/* Fixed Footer Skeleton */}
    <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4">
      <div className="flex items-center gap-3">
        <div className="h-10 bg-gray-300 rounded-lg w-28"></div>
        <div className="h-14 bg-gray-300 rounded-xl flex-1"></div>
      </div>
    </div>
  </div>
);

ItemModifierModalSkeleton.displayName = 'ItemModifierModalSkeleton';

export default ItemModifierModalSkeleton;
